export const EJSONProps = Object.freeze({
  STEP_NAME: 'stepName',
  STEP_SEQUENCE: 'stepSequence',
  ROW_NUMBER: 'row',
  CURRENT: 'ongoing',
  PRESENT: 'present',
  OPT_HIDE_BY_COUNTRY: 'hideByCountry'
})

export const EFlowElement = Object.freeze({
  ATTACHMENT_UPLOADER: 'ATTACHMENT_UPLOADER',
  BUTTON_BACK: 'BUTTON_BACK',
  BUTTON_FILL_MANUALLY: 'BUTTON_FILL_MANUALLY',
  BUTTON_INTERMEDIATE: 'BUTTON_INTERMEDIATE',
  BUTTON_PARSED_CONTINUE: 'BUTTON_PARSED_CONTINUE',
  BUTTON_SUBMIT: 'BUTTON_SUBMIT',
  CHECKBOX: 'CHECKBOX',
  CV_UPLOADER: 'CV_UPLOADER',
  CV_GENERATOR: 'CV_GENERATOR',
  DATE_DISABLER: 'DATE_DISABLER',
  DATE_PICKER: 'DATE_PICKER',
  DYNAMIC_FORM: 'DYNAMIC_FORM',
  MOTIVATION_INPUT: 'MOTIVATION_INPUT',
  PHONE_NOTIFICATION_CONSENT: 'PHONE_NOTIFICATION_CONSENT',
  PICKER_CATEGORIES: 'PICKER_CATEGORIES',
  PICKER_LANGUAGE: 'PICKER_LANGUAGE',
  PICKER_LE_COUNTRIES: 'PICKER_LE_COUNTRIES',
  PICKER_LOCATION: 'PICKER_LOCATION',
  PICKER_POOLS: 'PICKER_POOLS',
  PICKER_RADIUS: 'PICKER_RADIUS',
  PICKER_TAGS: 'PICKER_TAGS',
  PROFILE_ADDRESS: 'PROFILE_ADDRESS',
  RATE_FIELD: 'RATE_FIELD',
  REPEATER: 'REPEATER',
  SECURITY_ID: 'SECURITY_ID',
  SELECTOR_BUTTON: 'SELECTOR_BUTTON',
  SELECTOR_CALENDAR: 'SELECTOR_CALENDAR',
  SELECTOR_CHECK: 'SELECTOR_CHECK',
  SELECTOR_COUNTRY: 'SELECTOR_COUNTRY',
  SELECTOR_PHONE: 'SELECTOR_PHONE',
  SELECTOR_PLAIN: 'SELECTOR_PLAIN',
  SELECTOR_RADIO: 'SELECTOR_RADIO',
  SELECTOR_REFERRAL: 'SELECTOR_REFERRAL',
  TEXTAREA: 'TEXTAREA',
  TEXT_FIELD: 'TEXT_FIELD',
  TEXT_EDITOR: 'TEXT_EDITOR',
  TEXT_SOCIAL: 'TEXT_SOCIAL',
  TIME_PICKER: 'TIME_PICKER',
  UI_PLAIN_TEXT: 'UI_PLAIN_TEXT',
  UI_CLICK_ELEMENT: 'UI_CLICK_ELEMENT',
  UPLOAD_ATTACHMENTS: 'UPLOAD_ATTACHMENTS',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT'
})

export const EInternalTypes = Object.freeze({
  DATE_FULL: 'DATE_FULL',
  DATE_MONTH: 'DATE_MONTH',
  DATE_YEAR: 'DATE_YEAR',
  DATE_YEAR_ONLY: 'DATE_YEAR_ONLY'
})

export const EFlowDevice = Object.freeze({
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  FIREFOX: 'FIREFOX',
  CHROME: 'CHROME',
  SAFARI: 'SAFARI',
  EDGE: 'EDGE'
})

export const EFlowShowOn = Object.freeze({
  PROFILE_TALENT: 'PROFILE_TALENT',
  PROFILE_MSP: 'PROFILE_MSP',
  PROFILE_HIRING: 'PROFILE_HIRING',
  SHORT_ONBOARDING: 'SHORT_ONBOARDING',
  LONG_ONBOARDING: 'LONG_ONBOARDING',
  TALENT_APPLICATION: 'TALENT_APPLICATION'
})

export const EFlowAffiliate = Object.freeze({
  RANDSTAD: 'RANDSTAD'
})

export const EFlowText = Object.freeze({
  TITLE: 'TITLE',
  SUBTITLE: 'SUBTITLE',
  PARAGRAPH_SM: 'PARAGRAPH_SM',
  PARAGRAPH: 'PARAGRAPH',
  PARAGRAPH_LG: 'PARAGRAPH_LG',
  PARAGRAPH_Q: 'PARAGRAPH_Q',
  ALERT: 'ALERT'
})

export const EFlowAlert = Object.freeze({
  DEFAULT: 'black',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success'
})

export const EStepNav = Object.freeze({
  DEFINE: 'buttons',
  PREV: 'prev',
  NEXT: 'next'
})

export const EFlowRepeater = Object.freeze({
  JOB_HISTORY: 'j_h',
  EDU_HISTORY: 'e_h',
  CERT_HISTORY: 'c_h',
  CUSTOM_FIELD_REPEATER: 'REPEATER'
})

export const EFlowDocDeleteType = Object.freeze({
  KEEP_PARSING: 'KEEP_PARSING',
  CLEAR_PARSING: 'CLEAR_PARSING'
})

export const EFlowParseJson = Object.freeze({
  ...EFlowRepeater,
  FIELD_HOME_LINE1: 'homeAddressLine1',
  FIELD_HOME_LINE2: 'homeAddressLine2',
  FIELD_HOME_STREET: 'homeStreet',
  FIELD_HOME_ZIP: 'homeZip',
  FIELD_HOME_CITY: 'homeCity',
  FIELD_HOME_STATE: 'homeState',
  FIELD_HOME_COUNTRY: 'homeCountry',
  FIELD_PHONE: 'phoneNumber',
  FIELD_SKILLS: 'skill',
  FIELD_TOOLS_TECH: 'soft',
  FIELD_PROFESSIONAL_TITLE: 'professionalTitle',
  FIELD_DESCRIPTION: 'description',
  FIELD_LANG: 'language',
  FIELD_START_DATE: 'startDate',
  FIELD_END_DATE: 'endDate',
  FIELD_FIRST_NAME: 'firstName',
  FIELD_LAST_NAME: 'lastName',
  FIELD_TEXT_SOCIAL: 'linkedinHandle',
  FIELD_JOB_TITLE: 'jobTitle'
})

export const ETalentPanel = Object.freeze({
  ADDRESS: 'homeAddress',
  ATTACHMENTS: 'profile_attachments',
  CERTIFICATES: 'c_h',
  CONTACT_ADDRESS: 'homeAddress',
  CONTACT_PHONE: 'phoneNumber',
  COUNTRIES_OF_INTEREST: 'countriesOfInterest',
  EDUCATION: 'e_h',
  INDUSTRIES: 'ind',
  JOB_TITLE: 'jobTitle',
  LANGUAGES: 'language',
  LOCATION_TYPE: 'locationType',
  PHONE: 'phone',
  RESUME: 'upload',
  SKILLS: 'skill',
  SOCIAL_PROFILES: 'linkedinHandle',
  SUMMARY: 'summary',
  TECHNOLOGIES: 'soft',
  WORK_EXPERIENCE: 'j_h',
  CUSTOM_FIELD: 'customField'
})

export const ETalentAttachmentType = Object.freeze({
  HISTORY: 'history_attachment',
  PROFILE: 'profile_attachments'
})

export const EAddressField = Object.freeze({
  ADDRESS_LINE_1: 'homeAddressLine1',
  ADDRESS_LINE_2: 'homeAddressLine2',
  CITY: 'homeCity',
  COUNTRY: 'homeCountry',
  STATE: 'homeState',
  STREET: 'homeStreet',
  ZIP: 'homeZip'
})
export const allowedCustomTypes = [
  EFlowElement.TEXT_FIELD,
  EFlowElement.DATE_PICKER,
  EFlowElement.SELECTOR_RADIO,
  EFlowElement.SELECTOR_CHECK,
  EFlowElement.UPLOAD_ATTACHMENTS,
  EFlowElement.TEXTAREA,
  EFlowElement.DYNAMIC_FORM
]

export const EPDFBlockName = Object.freeze({
  COVER_LETTER: 'cl',
  RESUME: 'r',
  SCREENING_SHEET: 'ss'
})
